import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "../../data/site";

export default function ClientLogos() {
  return (
    <section
      className="border-y border-zinc-200 bg-zinc-50 py-10"
      aria-label="Trusted by app founders worldwide"
      data-testid="client-logos-section"
    >
      <div className="container">
        <p className="text-overline text-zinc-500 text-center mb-6">
          Trusted by 100+ app founders across 15+ markets
        </p>
      </div>
      <div className="marquee-mask">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {CLIENT_LOGOS.concat(CLIENT_LOGOS).map((name, i) => (
            <div
              key={`${name}-${i}`}
              className="mx-10 flex items-center gap-3 text-zinc-400 hover:text-charcoal transition-colors"
              data-testid={`client-logo-${i}`}
            >
              <span className="w-2 h-2 bg-zinc-300" />
              <span className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">
                {name}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
